var m;

m = require('mithril');

module.exports = function(store) {
  return function(next) {
    return function(action) {
      var result;
      m.startComputation();
      result = next(action);
      m.endComputation();
      return result;
    };
  };
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL2FwcC9zcmMvc3RhdGUvUmVkcmF3TWlkZGxld2FyZS5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvYXBwL3NyYy9zdGF0ZS9SZWRyYXdNaWRkbGV3YXJlLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBOztBQUFBLENBQUEsR0FBSSxPQUFBLENBQVEsU0FBUjs7QUFFSixNQUFNLENBQUMsT0FBUCxHQUFpQixTQUFDLEtBQUQ7U0FBVyxTQUFDLElBQUQ7V0FBVSxTQUFDLE1BQUQ7QUFFckMsVUFBQTtNQUFBLENBQUMsQ0FBQyxnQkFBRixDQUFBO01BQ0EsTUFBQSxHQUFTLElBQUEsQ0FBSyxNQUFMO01BQ1QsQ0FBQyxDQUFDLGNBQUYsQ0FBQTthQUVBO0lBTnFDO0VBQVY7QUFBWCJ9
